import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableResponsiveDirective } from '../table-responsive.directive';
import { TableResponsive2Directive } from '../table-responsive2.directive';



@NgModule({
  declarations: [TableResponsiveDirective, TableResponsive2Directive],
  exports: [TableResponsiveDirective, TableResponsive2Directive],
  imports: [
    CommonModule
  ]
})
export class ModDirectivasModule { }
